import axios from "axios";

const BASE_ROUTE = "case-details";

/** Detalles del caso (tra_case_details). Un caso sin renglon responde todo en falso. */
export const getCaseDetails = (caseId) => axios.get(`${BASE_ROUTE}/${caseId}`);

/** Actualiza solo los campos enviados; los nulos conservan lo guardado. */
export const updateCaseDetails = (caseId, data) => axios.put(`${BASE_ROUTE}/${caseId}`, data);
